import React, { useState } from 'react';
import logo from '../logo.png';
import WalletConnect from './WalletConnect';

const Header: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-gray-700/30 bg-gray-900/10 backdrop-blur-xl">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center">
            <div className="flex-shrink-0 flex items-center space-x-3">
              <img 
                src={logo} 
                alt="Magic UI Logo" 
                className="h-8 w-8 rounded-lg"
              />
              <h1 className="text-2xl font-bold bg-gradient-to-r from-white via-purple-100 to-white bg-clip-text text-transparent animate-glow hover:from-purple-300 hover:via-white hover:to-purple-300 transition-all duration-300">
                FarmMaster
              </h1>
            </div>
          </div>

          <nav className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              {/* <a
                href="#projects"
                className="text-gray-300 hover:text-purple-400 px-3 py-2 text-sm font-medium transition-all duration-300 relative group hover:scale-105"
              >
                支持项目
                <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-purple-400 to-violet-400 group-hover:w-full transition-all duration-300"></div>
              </a> */}
              {/* <a
                href="#pricing"
                className="text-gray-300 hover:text-purple-400 px-3 py-2 text-sm font-medium transition-all duration-300 relative group hover:scale-105"
              >
                定价方案
                <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-purple-400 to-violet-400 group-hover:w-full transition-all duration-300"></div>
              </a> */}
              {/* <a
                href="https://farmmaster.gitbook.io/farmmaster-shi-yong-wen-dang"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-purple-400 px-3 py-2 text-sm font-medium transition-all duration-300 relative group hover:scale-105"
              >
                使用文档
                <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-purple-400 to-violet-400 group-hover:w-full transition-all duration-300"></div>
              </a> */}
            </div>
          </nav>

          <div className="flex items-center space-x-4">
            {/* <WalletConnect /> */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden p-2 rounded-lg text-gray-300 hover:text-white hover:bg-gray-800/50 transition-colors"
              aria-label="Toggle mobile menu"
            >
              {isMobileMenuOpen ? (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-gray-900/20 backdrop-blur-xl border-t border-gray-700/30">
              <a
                href="#projects"
                className="block px-3 py-2 text-gray-300 hover:text-purple-400 text-base font-medium transition-colors hover:bg-purple-900/20 rounded-lg"
              >
                支持项目
              </a>
              {/* <a
                href="#pricing"
                className="block px-3 py-2 text-gray-300 hover:text-purple-400 text-base font-medium transition-colors hover:bg-purple-900/20 rounded-lg"
              >
                定价方案
              </a> */}
              <a
                href="https://farmmaster.gitbook.io/farmmaster-shi-yong-wen-dang"
                target="_blank"
                rel="noopener noreferrer"
                className="block px-3 py-2 text-gray-300 hover:text-purple-400 text-base font-medium transition-colors hover:bg-purple-900/20 rounded-lg"
              >
                使用文档
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;